import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "withdraw_page" }
const _hoisted_2 = { class: "withdraw_container" }
const _hoisted_3 = { class: "channel_text_title" }
const _hoisted_4 = { class: "channel_list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "channel_text"
}
const _hoisted_7 = { class: "currency" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "channel_container_center" }
const _hoisted_10 = { style: {"padding":"0px 16px"} }
const _hoisted_11 = { class: "channel_container" }
const _hoisted_12 = { class: "btn_container" }
const _hoisted_13 = {
  key: 2,
  class: "descriptionContainer"
}
const _hoisted_14 = { class: "noticeText" }
const _hoisted_15 = { key: 3 }

import { ref, computed, onMounted, reactive } from 'vue'
import InputField from '../withdraw/components/inputField.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { Channel, TAB_TYPE_LIST, WithdrawPopupData, WithdrawViewData } from '@/view/withdraw/supportScript';
import WithdrawViewTwo from './withdrawPopup.vue';
import { useWithdrawStore } from '@/stores/withdraw';
import { useUserStore } from '@/stores/user';
import { withdraw, withdrawSettingByUserID } from '@/api/withdraw';
import MainButton from '../components/common/mainButton.vue';
import CryptoWithdraw from './cryptoWithdraw.vue';
import { useRouter } from 'vue-router';
import WithdrawTopCard from '../components/common/topHeaderCard.vue';
import CustomHeader from '../components/common/customHeader.vue';
import AmountCard from './components/amountCard.vue';
import MainFooter from '../components/common/mainFooter.vue';
import { showToast } from 'vant';
import 'vant/es/toast/style';

export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawView',
  props: {
    dataSet: {}
  },
  emits: ['selectChannel', 'showError', 'showSuccess', 'showLoading', 'inputValueChange'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const withdrawStore = useWithdrawStore()
const userStore = useUserStore()
const router = useRouter()
const uId = computed(() => userStore.id)
const props = __props
const withdrawRef = ref<InstanceType<typeof WithdrawViewTwo>>()
const footerSelected = localStorage.getItem('footerPopupOpen')
const selectedChannel = computed(() => withdrawStore.selectedChannel as Channel)
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref('')
const emailID = ref('')
const phoneID = ref('')
const evpID = ref('')
const userName = ref('')
const cpfNumber = ref('')
const brazilID = ref('')
const bank = ref('')
const showCPFIdError = ref(true)
const showEmaiIdError = ref(true)
const showPhoneIdError = ref(true)
const showEvpIdError = ref(true)
const showCPFNumError = ref(false)
const activeButton = ref(props.dataSet.activeButton)
const isActiveButton = ref(false)
const selectedAmount = ref()
const isDisabled = ref(false)

const formValues = ref({
    cpfID: '',
    emailID: '',
    phoneID: '',
    evpID: '',
    userName: '',
    cpfNumber: '',
    brazilID: '',
    bank: '',
})

const dataSetTwo = reactive<WithdrawPopupData>({
    // show: show.value,
    selectedChannel: selectedChannel.value,
    activeTab: activeTab.value,
    cpfID: cpfID.value,
    emailID: emailID.value,
    phoneID: phoneID.value,
    evpID: evpID.value,
    userName: userName.value,
    cpfNumber: cpfNumber.value,
    brazilID: brazilID.value,
    bank: bank.value,
    showCPFIdError: showCPFIdError.value,
    showEmaiIdError: showEmaiIdError.value,
    showPhoneIdError: showPhoneIdError.value,
    showEvpIdError: showEvpIdError.value,
    showCPFNumError: showCPFNumError.value,
    activeButton: activeButton.value,
    selectedAmount: selectedAmount.value,
    isDisabled: isDisabled.value,
})

const amountList = ref([
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": 1,
        "updateTime": "2026-02-27 08:24:21",
        "tenantId": "000000",
        "id": 3,
        "fillValue": 10,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": null,
        "updateTime": "2026-01-08 07:37:17",
        "tenantId": "000000",
        "id": 4,
        "fillValue": 30,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": 1,
        "updateTime": "2026-01-08 07:37:16",
        "tenantId": "000000",
        "id": 5,
        "fillValue": 50,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": null,
        "updateTime": "2026-01-08 07:37:14",
        "tenantId": "000000",
        "id": 7,
        "fillValue": 100,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": 1,
        "updateTime": "2026-01-08 07:37:13",
        "tenantId": "000000",
        "id": 8,
        "fillValue": 300,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": null,
        "updateTime": "2025-07-07 05:06:19",
        "tenantId": "000000",
        "id": 9,
        "fillValue": 500,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": null,
        "updateTime": "2025-08-12 10:20:43",
        "tenantId": "000000",
        "id": 10,
        "fillValue": 1000,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": 1,
        "updateTime": "2025-07-07 07:13:41",
        "tenantId": "000000",
        "id": 11,
        "fillValue": 30000,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    }
])

const minAmount = computed(() => {
  if (!amountList.value.length) return 0
  return Math.min(...amountList.value.map(item => item.fillValue))
})

const maxAmount = computed(() => {
  if (!amountList.value.length) return 0
  return Math.max(...amountList.value.map(item => item.fillValue))
})

const isMainButtonActive = computed(() => props.dataSet.activeButton && isActiveButton.value)

const updateWithdrawFormValues = (values: any) => {
    formValues.value = { ...formValues.value, ...values }
}

const selectChannel = (item: PayChannel) => {
    emits('selectChannel', item)
}

const selectTabType = (item: any) => {
    activeTab.value = item
}

const confirmWithdrawUserId = () => {
    const data = { uid: uId.value }
    withdrawSettingByUserID(data)
        .then((res) => {
            confirmWithdrawApi()
        })
        .catch((err) => {
            if (err.code != 401) {
                emits('showError', err)
            }
        })
}

const confirmWithdrawApi = () => {
    emits('showLoading', true)
    const active = activeTab.value.name

    const data: any = {
        payment_channel_id: selectedChannel.value.id,
        amount: selectedAmount.value,
        tax_type: active,
        tax_id:
            active === 'CPF'
                ? formValues.value.cpfID
                : active === 'E-mail'
                    ? formValues.value.emailID
                    : active === 'PHONE'
                        ? formValues.value.phoneID
                        : active === 'EVP'
                            ? formValues.value.evpID
                            : '',
        account_name: formValues.value.userName,
        cpf_id: formValues.value.cpfNumber,
        uid: uId.value,
    }

    if (selectedChannel.value.channelType === '1') {
        data.bank_name = formValues.value.bank
    } else if (selectedChannel.value.channelType === '7') {
        data.bank_name = formValues.value.bank
        data.identity_no = formValues.value.brazilID
    }

    withdraw(data)
        .then((res) => {
            emits('showLoading', false)
            emits('showSuccess', res.msg)
            setTimeout(() => {
                userStore.getInfo()
            }, 500)
        })
        .catch((err) => {
            emits('showLoading', false)
            emits('showError', err)
            setTimeout(() => {
                userStore.getInfo()
            }, 500)
        })
}

const getWithdrawDetails = () => {
    let data = { uid: uId.value }
    withdrawSettingByUserID(data)
        .then(res => {
            const resData = res.data
            if (resData == null) return
            withdrawStore.setWithdrawInfo(resData)
            dataSetTwo.cpfID = resData?.cpf || ''
            dataSetTwo.emailID = resData?.email || ''
            dataSetTwo.phoneID = resData?.phone || ''
            dataSetTwo.evpID = resData?.evpId || ''
            dataSetTwo.userName = resData?.userName || ''
            dataSetTwo.cpfNumber = resData?.cpfId || ''
            dataSetTwo.brazilID = resData?.identityNo || ''
            dataSetTwo.isDisabled = resData?.isEditable == 1
        })
        .catch((err) => {
            if (err.code != 401) {
                emits('showError', err)
            }
        })
}

const changeValues = (data: any) => {
    if (data.type === 'cpfID') {
        cpfID.value = data.value
    } else if (data.type === 'emailID') {
        emailID.value = data.value
    } else if (data.type === 'phoneID') {
        phoneID.value = data.value
    } else if (data.type === 'evpID') {
        evpID.value = data.value
    } else if (data.type === 'cpfNumber') {
        cpfNumber.value = data.value
    } else if (data.type === 'userName') {
        userName.value = data.value
    } else if (data.type === 'brazilID') {
        brazilID.value = data.value
    } else if (data.type === 'bank') {
        bank.value = data.value
    }
}

const checkFieldsFill = (isActive: any) => {
    isActiveButton.value = isActive
}

const inputValueChange = (val: any) => {
    const currentBalance = props.dataSet?.balanceAmount ?? 0
    if (currentBalance < val) {
        selectedAmount.value = currentBalance
        
    } else {
        selectedAmount.value = val
    }
    // if (val > 0 && isActiveButton.value) {
    //     activeButton.value = true
    // } else {
    //     activeButton.value = false
    // }
    emits('inputValueChange', val)
    
}

const selectAmount = (val: number) => {

    const currentBalance = props.dataSet?.balanceAmount ?? 0

    if (val > currentBalance) {
        selectedAmount.value = currentBalance
        showToast('Saldo da conta insuficiente');
    } else {
        selectedAmount.value = val
    }
    inputValueChange(selectedAmount.value)
}

const backNavigate = () => {
    userStore.setRechargeBonusType(0)
    userStore.setTakeFirstDeposit(false)
    router.go(-1)
}
const goToFund = () => {
    router.replace({ path: '/fundsHistory', query: { tabIndex: 1 } })
}

onMounted(() => {
    getWithdrawDetails()
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WithdrawTopCard, {
      text: _ctx.$t('common.withdraw'),
      "sub-text": _ctx.$t('common.subText'),
      onClosePopup: backNavigate,
      "show-fund": true,
      onGoToFund: goToFund,
      hideBacKIcon: _unref(footerSelected) == '3'
    }, null, 8, ["text", "sub-text", "hideBacKIcon"]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"160px","background-color":"#024A49"} }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([
                'channel_container_top',
                _ctx.dataSet.activeChannel.channelType == '6' ? 'channel_container_top_crypto' : ''
            ])
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "line" }, null, -1)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.paymentChannelTitle')), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.channelList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["channel_card", _ctx.dataSet.activeChannel.id == item.id ? 'active_channel' : '']),
              key: item.name,
              onClick: ($event: any) => (selectChannel(item))
            }, _toDisplayString(item.name), 11, _hoisted_5))
          }), 128))
        ]),
        (_ctx.dataSet.activeChannel.channelType != '6')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.$t('common.paymentChannelTotal')) + " ", 1),
              _createElementVNode("span", _hoisted_7, " R$ " + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet?.balanceAmount || 0)), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.dataSet.activeChannel.channelType == '6')
        ? (_openBlock(), _createBlock(CryptoWithdraw, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(InputField, {
                  modelValue: selectedAmount.value,
                  labelText: `${_unref(formatCurrency)(minAmount.value)} - ${_unref(formatCurrency)(maxAmount.value)}`,
                  onValueChanged: inputValueChange,
                  maxLimit: _ctx.dataSet.balanceAmount
                }, null, 8, ["modelValue", "labelText", "maxLimit"]),
                _createVNode(_component_van_row, { class: "amount_card_list" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(amountList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_van_col, {
                        span: "8",
                        key: item.fillValue,
                        style: {"padding":"10px 5px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(AmountCard, {
                            amount: item.fillValue,
                            isActiveAmount: selectedAmount.value == item.fillValue,
                            onHandleCardClick: ($event: any) => (selectAmount(item.fillValue))
                          }, null, 8, ["amount", "isActiveAmount", "onHandleCardClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(WithdrawViewTwo, {
                ref_key: "withdrawRef",
                ref: withdrawRef,
                "data-set-two": dataSetTwo,
                "onUpdate:dataSetTwo": _cache[0] || (_cache[0] = ($event: any) => ((dataSetTwo) = $event)),
                onConfirmWithdrawPopup: confirmWithdrawUserId,
                onInputValueChange: inputValueChange,
                onSelectChannel: selectChannel,
                onSelectTabType: selectTabType,
                onUpdateFormValues: updateWithdrawFormValues,
                onChangeValue: changeValues,
                onCheckFieldsFill: checkFieldsFill
              }, null, 8, ["data-set-two"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(MainButton, {
                title: _ctx.$t('common.retirarAgora'),
                activeStatus: isMainButtonActive.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (withdrawRef.value?.confirmWithdraw())),
                radius: '8px',
                "btn-padding": '28px',
                forceGradientWhenDisabled: true
              }, null, 8, ["title", "activeStatus"])
            ])
          ])),
      (_ctx.dataSet?.withdrawControls?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('common.notice')), 1),
            _createVNode(_component_van_row, { class: "tabelHeader" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "tabeldata"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('withdraw.rechargeTimes')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "tabeldata"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('withdraw.rechargeAmount')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet?.withdrawControls, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                key: index,
                class: _normalizeClass(index % 2 === 0 ? 'row-dark' : 'row-light')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "tabeldata"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.rechargeTime) + " X", 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "tabeldata"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.minAmount), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_unref(userStore).footerComponent && _unref(footerSelected) != '4')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(MainFooter, {
              itemData: _unref(userStore).footerComponent,
              activeFooter: 4
            }, null, 8, ["itemData"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})